
import React from "react";
import { IconProps, getSocialIconColor } from "../SocialIcon";

export const Instagram: React.FC<IconProps> = (props) => {
  const fill = getSocialIconColor({
    ...props,
    colorFill: "#C13584"
  });

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="96px" height="96px" viewBox="0 0 96 96">
      <title>Instagram</title>
      <path id="Instagram-2" fill={fill} d="M84.6,0H11.4C5.1,0,0,5.1,0,11.4l0,0v73.2C0,90.9,5.1,96,11.4,96h73.2
        C90.9,96,96,90.9,96,84.6V11.4C96,5.1,90.9,0,84.6,0L84.6,0z M69,15c0-1.7,1.3-3,3-3h9c1.7,0,3,1.3,3,3v9c0,1.7-1.3,3-3,3h-9
        c-1.7,0-3-1.3-3-3V15z M48.1,29.7c10.2,0,18.4,8.3,18.4,18.5S58.2,66.6,48,66.6s-18.4-8.3-18.4-18.4C29.7,37.9,37.9,29.7,48.1,29.7
        L48.1,29.7z M87,84c0,1.7-1.3,3-3,3H12c-1.7,0-3-1.3-3-3V39h12c-1.6,2.2-2.1,6.5-2.1,9.1c0,16.1,13.1,29.2,29.2,29.2
        s29.2-13.1,29.2-29.2c0-2.7-0.4-6.8-2.3-9.1h12V84L87,84z"/>
    </svg>
  )
}
